// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1664":"4e20f3db7a342ffa","1698":"c07dfd040fc882e2","4896":"84f6640a228a67d3","5249":"25b0940c2fdd91e3","5259":"fc301960a33d88b1","8199":"f01407468f07465e"}[chunkId] + ".css";
};